/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Givefeedbacktitle_V22Inputs */

const en_settings_givefeedbacktitle_v22 = /** @type {(inputs: Settings_Givefeedbacktitle_V22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give feedback`)
};

/**
* | output |
* | --- |
* | "Give feedback" |
*
* @param {Settings_Givefeedbacktitle_V22Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_givefeedbacktitle_v22 = /** @type {((inputs?: Settings_Givefeedbacktitle_V22Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Givefeedbacktitle_V22Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_givefeedbacktitle_v22(inputs)
});
export { settings_givefeedbacktitle_v22 as "settings_giveFeedbackTitle_v2" }